import each from 'lodash/each'

const BASIC = (state, payload) => {
  state[payload.key] = payload.value
}

const IS_ASIDE_WIDE_ACTIVE = (state, payload) => {
  state.isAsideWideActive = payload
  state.isAsideVisible = payload
  each(
    ['has-aside-left','is-aside-active'],
    htmlClass => {
      if (!payload) {
        document.documentElement.classList.remove(htmlClass)
      } else {
        document.documentElement.classList.add(htmlClass)
      }
    }
  )
}

const SECONDARY_MENU = (state, payload) => {
  state.secondaryMenu = payload
}

const PRIMARY_MENU_IS_ACTIVE_FORCED_STATE = (state, payload) => {
  state.primaryMenuIsActiveForcedState = payload
}

const MAIN_PAGE = (state, payload) => {
  state.isHeroBarMainActive = true
  state.heroBarHeadline = null
  state.titleBarTitleStack = payload.stack
}

const SUB_PAGE = (state, payload) => {
  state.isHeroBarMainActive = false
  state.titleBarTitleStack = payload.stack
  state.heroBarHeadline = payload.title
}

const FULL_PAGE = (state, payload) => {
  state.isAsideVisible = !payload
  state.isNavBarVisible = !payload
  state.isTitleBarVisible = !payload
  state.isHeroBarVisible = !payload
  state.isFooterBarVisible = !payload
}

export default {
  IS_ASIDE_WIDE_ACTIVE,
  SECONDARY_MENU,
  PRIMARY_MENU_IS_ACTIVE_FORCED_STATE,
  MAIN_PAGE,
  SUB_PAGE,
  FULL_PAGE,
  BASIC
}
